export default __webpack_public_path__ + "static/media/google_classroom_icon.a477848f.svg";